import AudioManager from "./AudioManager"

class EnterSoundManager {
    private _playedSounds: Array<string> = []
    private _curSoundID = null

    playSound (url: string) {
        // 中文以外不播放
        if (cc.sys.localStorage.getItem("CurrentLanguage") !== "zh_CN") return
        if (this._playedSounds.indexOf(url) === -1) {
            this._playedSounds.push(url)
            this._curSoundID && cc.audioEngine.stopEffect(this._curSoundID)
            AudioManager.playSound(url, false, function (soundID) {
                this._curSoundID = soundID
            }.bind(this))
        }
    }
}

export default new EnterSoundManager()